import { useQuery } from '@tanstack/react-query'
import { ISelectedAttributes } from '../../../interfaces'
import { useAppSelector } from '../../../../../redux/hook'
import { AnalysisData } from '../Types'
import { fetchAnalysisData } from '../../../../../services/analysisViewServices'

export const useGetAnalysisViewData = (
    orgId: string,
    viewID: string,
    selectedAttributes: ISelectedAttributes[],
    startDate: string,
    endDate: string,
): ReturnType<typeof useQuery<AnalysisData>> => {
    const user = useAppSelector((state) => state.user.user)
    const isGuestUser =
        useAppSelector((state) => state.searchParams.isGuestUser) === 'true'
    const loginOrgId = useAppSelector((state) => state.org.org?.id || '')
    const guestUserPreferredUnit = useAppSelector(
        (state) => state.entityInstanceView.guestUserPreferredUnit,
    )
    return useQuery<AnalysisData>({
        queryKey: [
            'AnalysisViewData',
            orgId,
            viewID,
            selectedAttributes,
            startDate,
            endDate,
            user,
            guestUserPreferredUnit,
        ],
        queryFn: async (): Promise<AnalysisData> => {
            if (!orgId) {
                return {} as unknown as AnalysisData
            }
            return fetchAnalysisData(
                orgId,
                viewID,
                selectedAttributes,
                startDate,
                endDate,
                isGuestUser,
                loginOrgId,
                guestUserPreferredUnit,
            )
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 0, // Data never changes unless start date, end date or selected attributes change
        gcTime: 1000 * 60 * 60, // 1 hour
        enabled: !!selectedAttributes && !!startDate && !!endDate,
    })
}
